import fp from 'lodash/fp'
import { types } from 'mobx-state-tree'
import { isValid, toDate, parseISO } from 'date-fns'

export const ConvertableDate = types.custom({
  name: 'ConvertableDate',
  fromSnapshot(value) {
    const val = fp.isString(value) ? parseISO(value) : toDate(value)

    return val
  },

  toSnapshot(value) {
    return value.toString()
  },

  isTargetType(value) {
    const date = fp.isString(value) ? parseISO(value) : value
    return isValid(date)
  },

  getValidationMessage(value) {
    if (isValid(value)) return ''
    return `'${value}' doesn't look like covertable date`
  },
})
